export const DoNotAutoSplit = 'DoNotAutoSplit';
export const SplitOnLineItem = 'SplitOnLineItem';
export const SplitOnQuantity = 'SplitOnQuantity';
export const SplitOnCustomQty = 'SplitOnCustomQuantity';

export const MinimumSplitOnCustomQty = 1;
